// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7851":"bb997cfd","9093":"bb997cfd"}[chunkId] + ".chunk.css";
};